export const LastEventLogSortKey = 'event_log_name'
export const LastEventLogSortKeyAlias = 'last_event_log_name'

const isPresent = (value?: string | null): value is string => (
  typeof value === 'string' && value.trim().length > 0
)

const LastEventLogSourceLabels: Record<string, string> = {
  MamoriosEventTrigger: '退場通知',
  DeviceEventTrigger: '入場通知',
  StayNotification: '滞在時間通知',
  Tenko: '点呼',
  SequenceNotification: '順序通知',
}

const translateLastEventLogName = (value: string): string => (
  LastEventLogSourceLabels[value] ?? value
)

export const getLastEventLogName = (lastEventLog?: ILastEventLog | null): string => {
  if (!lastEventLog) return '-'

  if (isPresent(lastEventLog.source_label)) return translateLastEventLogName(lastEventLog.source_label)
  if (isPresent(lastEventLog.source_type)) return translateLastEventLogName(lastEventLog.source_type)
  if (isPresent(lastEventLog.event_name)) return translateLastEventLogName(lastEventLog.event_name)

  return '-'
}

export const hasLastEventLogEnabledGroup = (groups?: IGroup[] | null): boolean => (
  Boolean(groups?.some((group) => (
    group.last_event_log_enabled || hasLastEventLogEnabledGroup(group.child_groups)
  )))
)

export const findGroupById = (
  groups: IGroup[] | null | undefined,
  groupId: GroupId | number | null | undefined,
): IGroup | null => {
  if (!groups || !groupId) return null

  return groups.reduce<IGroup | null>((foundGroup, group) => {
    if (foundGroup) return foundGroup
    if (Number(group.id) === Number(groupId)) return group

    return findGroupById(group.child_groups, groupId)
  }, null)
}

export const isLastEventLogEnabledForMamorio = (
  mamorio: IMamorio,
  groups?: IGroup[] | null,
): boolean => Boolean(findGroupById(groups, mamorio.group_id)?.last_event_log_enabled)
